export const compareClubKisten = (a, b) => {
  // sort method to deal with [M11, PH-1233, M2] being sorted to [M2, M11, PH-1233]
  const diff = parseInt(a.callsign?.replace(/\D+/g, '')) - parseInt(b.callsign?.replace(/\D+/g, ''))
  if (isNaN(diff)) return a.callsign > b.callsign
  return diff
}

export const sortClubKisten = (kisten) => {
  return kisten.sort(compareClubKisten)
}

export const normalizeMeldingen = (meldingen, material, technici) => {
  // add join in frontend between meldingen and material, reduces load on backend
  const material_lookup = material.reduce((all, mat) => {
    all[mat.id] = mat
    return all
  }, {})
  const technici_lookup = technici.reduce((all, mat) => {
    all[mat.id] = mat
    return all
  }, {})

  meldingen.map(m => {
    m.material = material_lookup[m.material_id]
    m.material_name = m.material?.name
    m.technicus = technici_lookup[m.technicus_id]
    m.technicus_name = m.technicus?.name
  })
  return meldingen
}

export const normalizeMaterial = (material) => {
  // add total minutes per kist
  let output = []
  material.forEach(mat => output.push(normalizeSingleMaterial(mat)))

  output = output.sort((a, b) => a.order - b.order)
  return output
}

export const normalizeSingleMaterial = (mat) => {
  mat.material_name = mat.name

  mat.name_lowercase = mat.name?.toLowerCase()

  return mat
}

export const normalizePartsListForCascade = (parts) => {
  // reduce partslist for cascade function to parse, contains a recursive function on itself
  if (!parts) return []
  const normalize = (part) => ({ value: part.id, label: part.name, children: part.parts.map(p => normalize(p)) })
  return parts?.map(part => normalize(part))
}
